(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["theme__header"]) return;
  try {
    
(() => {
  const header = document.querySelector('header[x-ref="header"]');
  if (!header || header.dataset.jzwScrollBound === 'true') return;
  header.dataset.jzwScrollBound = 'true';
  const mobile = window.matchMedia('(max-width: 767px)');
  let previous = Math.max(0, window.scrollY || 0);
  const update = () => {
    const current = Math.max(0, window.scrollY || 0);
    const movement = current - previous;
    if (!mobile.matches || current < 110 || header.contains(document.activeElement) || document.querySelector('dialog[open]')) {
      header.classList.remove('jzw-hide-on-down');
      previous = current;
      return;
    }
    if (movement > 10) { header.classList.add('jzw-hide-on-down'); previous = current; }
    else if (movement < -10) { header.classList.remove('jzw-hide-on-down'); previous = current; }
  };
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();
})();
